export default "__VITE_ASSET__DMYcMjRd__"